<template>
    <a :href="`/user/?id=${ id }`" target="_blank">{{ name }}</a>
</template>

<script>
export default {
    props: {
        name: String,
        id: {}
    }
}
</script>

<style>

</style>